import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { MenuLeft } from "../../Components/MenuLeft";

interface PractitionerData {
  uuidPractitioner: string;
  uuidOrganization: string;
  namePractitioner: string;
  room: string;
  floor: string;
}

interface FormData {
  [key: string]: PractitionerData;
}

const SAVE_CONCURRENCY = 5;

export const Practitioner = () => {
  const globalContext = useContext(AuthContext);
  const [token] = useState<string | null>(localStorage.getItem("authToken"));
  const [practitioners, setPractitioners] = useState<any[]>([]);
  const [formData, setFormData] = useState<FormData>({});
  // Snapshot dos dados como estavam no último fetch/save, para saber o que realmente mudou.
  const baselineRef = useRef<FormData>({});
  //const [dadosAtu,setDadosAtu] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!token) return;

        const response = await axios.all([
          axios.get(
            `https://api.cadclin.com.br/prod/systemuser/?role=practitioner&status=active&pagesize=9999`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
          axios.get(
            `https://painel-api.medc.com.br/practitionerAll/${globalContext.user?.organization}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              }
            }
          ),
        ]);

        const practitionersData: any[] = response[0].data.entry;
        const dadosAtu: any[] = response[1].data;

        const initialFormData: FormData = {};

         //Quando a tabela estiver vazia
        
        for (const practitioner of practitionersData) {
          const practitionerId = practitioner.content.id;
          const namePractitioner = practitioner.content.name.given;
          
          initialFormData[practitionerId] = {
            uuidPractitioner: practitionerId,
            uuidOrganization: globalContext.user?.organization || "",
            namePractitioner: namePractitioner,
            room: "",
            floor: "",
          };
        }
        
        //Form Preenchido

        for (const practitioner of dadosAtu) {
          //console.log(practitioner);
          const practitionerId = practitioner.uuidPractitioner;
          const namePractitioner = practitioner.namePractitioner;
          const roomPractitioner = practitioner.room;
          const floorPractitioner = practitioner.floor;
          

          initialFormData[practitionerId] = {
            uuidPractitioner: practitionerId,
            uuidOrganization: globalContext.user?.organization || "",
            namePractitioner: namePractitioner,
            room: roomPractitioner,
            floor: floorPractitioner,
          };
        }
        
        //Setando os dados no FORM

        setFormData(initialFormData);
        baselineRef.current = initialFormData;
        setPractitioners(practitionersData);
      } catch (error) {
        console.error("Erro ao buscar médicos:", error);
      }
    };
    fetchData();
  }, [token, globalContext.user?.organization]);

  //Função de execução

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Só reenvia quem realmente teve sala/andar alterados desde o último fetch/save,
    // em vez de reenviar a lista inteira de médicos a cada clique em Salvar.
    const changedIds = Object.keys(formData).filter((practitionerId) => {
      const current = formData[practitionerId];
      const original = baselineRef.current[practitionerId];
      return (
        !original ||
        current.room !== original.room ||
        current.floor !== original.floor
      );
    });

    if (changedIds.length === 0) {
      alert("Nenhuma alteração para salvar.");
      return;
    }

    const saveOne = async (practitionerId: string) => {
      const {
        namePractitioner,
        room,
        floor,
        uuidPractitioner,
        uuidOrganization,
      } = formData[practitionerId];

      const dataUpdate = {
        idPractitioner: uuidPractitioner,
        uuidOrganization,
        namePractitioner,
        room,
        floor,
      };

      try {
        // O backend faz upsert: atualiza se o médico já existir, cria se não existir.
        await axios.put(`https://painel-api.medc.com.br/practitioner`, dataUpdate, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        console.error(
          `Erro ao atualizar médico com ID ${practitionerId}:`,
          error
        );
        throw error;
      }
    };

    // Processa em lotes pequenos para não disparar centenas de requisições
    // simultâneas contra o backend.
    const errors: unknown[] = [];
    for (let i = 0; i < changedIds.length; i += SAVE_CONCURRENCY) {
      const batch = changedIds.slice(i, i + SAVE_CONCURRENCY);
      const results = await Promise.allSettled(batch.map(saveOne));
      results.forEach((result) => {
        if (result.status === "rejected") {
          errors.push(result.reason);
        }
      });
    }

    if (errors.length === 0) {
      baselineRef.current = formData;
      alert("Dados salvos com sucesso!");
    } else {
      console.error("Erro ao salvar dados. Por favor, tente novamente.");
      alert(
        `Falha ao salvar ${errors.length} de ${changedIds.length} médico(s). Tente novamente.`
      );
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    practitionerId: string
  ) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [practitionerId]: {
        ...prevFormData[practitionerId],
        [name]: value,
      },
    }));
  };

  return (
    <>
      <MenuLeft />
      <div style={{flex: 9}}>
        <div className="container-fluid">
          <div className="row">
            <div className="card col-md-12">
              <div className="card-body">
                <h5 className="mb-12">Médicos</h5>

                <form onSubmit={onSubmit}>
                  {practitioners.map((practitioner: any) => (
                      <div
                          className="form-row col-md-12"
                          key={practitioner.content.id}
                      >
                        <div className="form-group col-md-4">
                          <label
                              htmlFor={`inputMedico_${practitioner.content.id}`}
                          >
                            Médico
                          </label>
                          <input
                              name="namePractitioner"
                              type="text"
                              className="form-control"
                              id={`inputMedico_${practitioner.content.id}`}
                              value={
                                  formData[practitioner.content.id]
                                      ?.namePractitioner || ""
                              }
                              readOnly
                          />
                        </div>
                        <div className="form-group col-md-4">
                          <label htmlFor={`inputRoom_${practitioner.content.id}`}>
                            Sala
                          </label>
                          <input
                              name="room"
                              type="text"
                              className="form-control"
                              id={`inputRoom_${practitioner.content.id}`}
                              placeholder="SALA"
                              value={formData[practitioner.content.id]?.room || ""}
                              onChange={(e) =>
                                  handleInputChange(e, practitioner.content.id)
                              }
                          />
                        </div>
                        <div className="form-group col-md-4">
                          <label
                              htmlFor={`inputFloor_${practitioner.content.id}`}
                          >
                            Andar
                          </label>
                          <input
                              name="floor"
                              type="text"
                              className="form-control"
                              id={`inputFloor_${practitioner.content.id}`}
                              value={formData[practitioner.content.id]?.floor || ""}
                              onChange={(e) =>
                                  handleInputChange(e, practitioner.content.id)
                              }
                          />
                        </div>
                      </div>
                  ))}

                  <button
                      type="submit"
                      className="btn btn-primary d-block mt-3"
                  >
                    Salvar
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      <footer className="page-footer">
        <div className="footer-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-sm-6">
                <p className="mb-0 text-muted">Cadclin @2023</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      </div>
    </>
  );
};
